import { contentCard } from "@omni/components/components/General/ContentCard/contentCard.styles";
import { ResponsiveImageMapper } from "@omni/mappers/components/image/responsiveImage.mapper";
import { ContentCardProps } from "@omni/types/components/props/contentCard.props";
import { Card } from "@omni/ui/components/Card/card";
import { card } from "@omni/ui/components/Card/card.style";
import { Image } from "@omni/ui/components/Image/image";
import { cn } from "@omni/utils/styles";

const ContentCard = ({
    link,
    title,
    linkText,
    description,
    lazyLoading,
    responsiveImage
}: ContentCardProps) => {
    const TitleTag = title?.element || "h3";

    const imageProps = ResponsiveImageMapper.fromCoreToFrontEnd({
        image: responsiveImage,
        lazyLoading
    });

    const { image } = card();
    const { base, image: contentCardImage } = contentCard();

    return (
        <Card
            tag="a"
            border={true}
            className={base({ className: "tw:rounded-md!" })}
            href={link}
        >
            {imageProps && (
                <Image
                    {...imageProps}
                    className={cn("tw:p-2!")}
                >
                    <Image.Img
                        className={contentCardImage({
                            className: image({
                                className: "tw:aspect-4/3! tw:rounded-md!",
                                border: false,
                                imgAlignment: "top"
                            })
                        })}
                    />
                </Image>
            )}

            <Card.Body className={cn("tw:p-4! tw:py-2! tw:grow")}>
                {title && (
                    <Card.Title
                        tag={TitleTag}
                        className={cn("tw:text-primary tw:not-italic!")}
                    >
                        {title?.text}
                    </Card.Title>
                )}
                {description && (
                    <Card.Text
                        className={cn("tw:mb-0!")}
                        dangerouslySetInnerHTML={{ __html: description }}
                    ></Card.Text>
                )}
            </Card.Body>
            {linkText && (
                <Card.Footer className={cn("tw:p-4! tw:py-2!")}>
                    <Card.Link
                        className={cn("tw:font-semibold")}
                        color={"primary"}
                        outline={true}
                        fullWidth={true}
                    >
                        {linkText}
                        <i
                            className={cn(
                                "las la-lg la-angle-right tw:ml-2 tw:self-center"
                            )}
                        ></i>
                    </Card.Link>
                </Card.Footer>
            )}
        </Card>
    );
};

export { ContentCard };
